import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { USER_STATE_STORAGE_KEY, user } from './user'
import loading from './loading'
import { lessonRequest } from './lessonRequest'
import { student } from './student'
import { students } from './students'
import { teachers } from './teachers'
import { lessonPlan } from './lessonPlan'
import { reserve } from './reserve'
import { notifiedLesson } from './notifiedLesson'
import { requestModifyLesson } from './requestModifyLesson'
import { manageInvoice } from './manageInvoice'
import { teacherReview } from './teacherReview'
import { adminStudent, adminTeacher, adminLesson, adminMonthlyCompleteReports, adminAnnouncement } from './admin'
import { reportMonthlyComplete } from './teacherTop'
import { studentInvoices } from './studentInvoice'
import { teacherRewards } from './teacherRewards'
import { teacher } from './teacher'
import * as messageToStudent from './messageToStudent'
import { plannedTeacherLessons } from './plannedTeacherLessons'
import { plannedStudentLessons } from './plannedStudentLessons'
import { monthlyTeacherLessons } from './monthlyTeacherLessons'
import { privateTeachers } from './privateTeachers'
import { conversationTeachers } from './conversationTeachers'
import { allTeachers } from './allTeachers'
import { conversationTickets } from './studentTop/conversationTickets'
import { adminConversationTickets } from './admin/conversationTickets'
import { checkConnection } from './teacherSchedule'
import { previouslyBookedTeachers } from './studentTop'
import { announcement } from './announcement'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		user,
		loading,
		lessonRequest,
		student,
		students,
		teachers,
		lessonPlan,
		adminStudent,
		adminTeacher,
		adminLesson,
		adminMonthlyCompleteReports,
		adminAnnouncement,
		notifiedLesson,
		requestModifyLesson,
		manageInvoice,
		teacherReview,
		reserve,
		reportMonthlyComplete,
		messageToStudent,
		studentInvoices,
		teacherRewards,
		teacher,
		plannedTeacherLessons,
		plannedStudentLessons,
		monthlyTeacherLessons,
		privateTeachers,
		conversationTeachers,
		allTeachers,
		conversationTickets,
		adminConversationTickets,
		checkConnection,
		previouslyBookedTeachers,
		announcement
	},
	plugins: [
		createPersistedState({
			key: USER_STATE_STORAGE_KEY,
			paths: ['user']
		})
	]
})

export default store
